// extracted by mini-css-extract-plugin
export default {"root":"root___KpoWI","copy_link":"copy_link___d40Ov","img":"img___k7IXR"};